import _jsx from "@babel/runtime/helpers/jsx";
import React from 'react';
import xss from 'xss';
import getData from './getData';
function Website() {
  return /*#__PURE__*/_jsx("script", {
    type: "application/ld+json",
    dangerouslySetInnerHTML: {
      __html: xss(JSON.stringify(getData()), {
        stripIgnoreTag: true
      })
    } /* eslint-disable-line */
  });
}
export default Website;